// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__cquRd","imageUploader":"EGiftCard_imageUploader__1hTFz"};